"use strict";
exports.__esModule = true;
exports.ActivitiesAccordionContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-accordion-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAccordionContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-accordion-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeMoreDetailsClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-more-details',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayCategoryInCityItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-category-in-city-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayCategoryInCityItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-category-in-city-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFilterCitiesOptionClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-filter-cities-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFilterFeaturesOptionClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-filter-features-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAlertMessageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-alert-message',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesInCitySearchSeeAllResultKeyPressEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-in-city-search-see-all-result',
        action_type: 'key-press',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEmptyStatePopularDestinationsContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-empty-state-popular-destinations-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEmptyStateTopActivitiesContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-empty-state-top-activities-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesContinueYourBookingCardClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesContinueYourBookingCardSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesContinueYourBookingToastNotificationClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-toast-notification',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesContinueYourBookingToastNotificationSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-toast-notification',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSortAndFilterApplyButtonClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-apply-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesSortAndFilterClearButtonClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-clear-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesCategoriesAccordionClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-categories-accordion',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCategoriesAccordionSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-categories-accordion',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesClearAllCategoriesButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-clear-all-categories-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCloseBottomSheetClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-close-bottom-sheet',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularFiltersContainerSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-popular-filters-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPopularFiltersOptionClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-popular-filters-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPopularFiltersOptionHoverEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-popular-filters-option',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSortAndFilterApplyButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-apply-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesSortAndFilterClearButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-clear-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesSubcategoriesFilterClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSubcategoriesFilterSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-filter',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSubcategoriesSeeLessButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-see-less-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSubcategoriesSeeLessButtonSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-see-less-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSubcategoriesSeeMoreButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-see-more-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSubcategoriesSeeMoreButtonSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-subcategories-see-more-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesPopularSubcategoriesSectionChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-subcategories-section-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularSubcategoriesSectionChipSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-subcategories-section-chip',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularSubcategoriesSectionContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-subcategories-section-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularSubcategoriesSectionSeeMoreClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-subcategories-section-see-more',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularSubcategoriesSectionSeeMoreSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-subcategories-section-see-more',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCloseCustomSheetClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-close-custom-sheet',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGlobalKeywordSearchSeeAllResultKeyPressEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-global-keyword-search-see-all-result',
        action_type: 'key-press',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWebViewHeaderShareButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-web-view-header-share-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingOptionsEditButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-options-edit-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesContinueYourBookingCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesContinueYourBookingCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesContinueYourBookingContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-continue-your-booking-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferInclusionSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-inclusion',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeMoreInclusionButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-more-inclusion-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGlobalKeywordSearchClearClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-global-keyword-search-clear',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGlobalKeywordSearchNothingFoundSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-global-keyword-search-nothing-found',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGlobalKeywordSearchSeeAllResultClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-global-keyword-search-see-all-result',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.CrossSellWidgetActivitiesSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.CrossSellWidgetActivitiesTravelEssentialsClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-travel-essentials',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesTravelEssentialsSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-travel-essentials',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesClearAllCategoriesButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-clear-all-categories-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularFiltersOptionHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-filters-option',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesQuickSubcategoryFilterItemHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-quick-subcategory-filter-item',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCategoriesAccordionClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-categories-accordion',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCategoriesAccordionSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-categories-accordion',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesQuickSubcategoryFilterItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-quick-subcategory-filter-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesQuickSubcategoryFilterItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-quick-subcategory-filter-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesFilterClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesFilterSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-filter',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesSeeLessButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-see-less-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesSeeLessButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-see-less-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesSeeMoreButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-see-more-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSubcategoriesSeeMoreButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-subcategories-see-more-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesFilterDurationOptionClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesFilterPriceSliderThumbClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-filter-price-slider-thumb',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesPopularFiltersContainerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-popular-filters-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesPopularFiltersOptionClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-popular-filters-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSearchSelectedFilterChipClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-search-selected-filter-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSearchSelectedFilterClearAllButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-search-selected-filter-clear-all-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSortAndFilterApplyButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-apply-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSortAndFilterClearButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-clear-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSortAndFilterOpenButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-open-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSortOptionClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesHighlightsTooltipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlights-tooltip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHighlightsTooltipHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlights-tooltip',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHighlightsContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlights-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHighlightsItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlights-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHighlightsTooltipSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlights-tooltip',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularFiltersContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-filters-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopularFiltersOptionClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popular-filters-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV12 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 12
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV12 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 12
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV12 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 12
    }
};
exports.ActivitiesTopActivitiesAroundYouCardClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesTopActivitiesAroundYouCardSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesTopActivitiesAroundYouCarouselArrowButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-carousel-arrow-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesTopActivitiesAroundYouCarouselSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-carousel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActiviitesWebViewHeaderContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activiites-web-view-header-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWebViewHeaderBackButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-web-view-header-back-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWebViewHeaderCartButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-web-view-header-cart-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFloatingSidePanelSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-floating-side-panel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAboutActivityContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-about-activity-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAboutActivityContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-about-activity-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonSeenEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesAvailableOptionCardHoverEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesAvailableOptionCardSeenEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesMoreDatesButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-more-dates-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverviewModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overview-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverviewSheetSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overview-sheet',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReadMoreButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-read-more-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDetailsKeyInfoListSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-details-key-info-list',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV11 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 11
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV11 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 11
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV11 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 11
    }
};
exports.ActivitiesCardFeaturesClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardFeaturesHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardPriceClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardPriceHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardTitleClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardTitleHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesViewAllImagesButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-view-all-images-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBadgeHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesBadgeSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesPoiCardHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-poi-card',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPoiCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-poi-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPoiContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-poi-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPoiListItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-poi-list-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesMiniAccordionToggleClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-mini-accordion-toggle',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesMiniClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-mini',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesMiniSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-mini',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEditSearchCloseButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-edit-search-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesEditSearchDateInputClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-edit-search-date-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesEditSearchModalSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-edit-search-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesEditSearchSearchInputClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-edit-search-search-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesErrorComponentSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-error-component',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesHeaderSearchBarClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-header-search-bar',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPageContentErrorButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-page-content-error-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesSearchButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-search-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesHeaderSearchBarTextInputChangeEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'change',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesHeaderSearchBarTextInputClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesHeaderSearchBarTextInputSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesLandingTextInputChangeEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-landing-text-input',
        action_type: 'change',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchInputChangeEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-input',
        action_type: 'change',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHeaderSearchBarTextInputChangeEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'change',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBadgeHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBadgeSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesDealsBadgesContainerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-deals-badges-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesHighlightBadgesContainerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-highlight-badges-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesFilterClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesFilterSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-filter',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesViewAllClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-view-all',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesViewAllSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-view-all',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightEditClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-edit',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightEditSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-edit',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightLoadingSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-loading',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightViewAllClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-view-all',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetFlightViewAllSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-view-all',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetHeaderSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-header',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetHotelClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-hotel',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetHotelSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-hotel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetTripSavingAppliedBannerClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-saving-applied-banner',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetTripSavingAppliedBannerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-saving-applied-banner',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetTripSavingsBottomSheetClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-savings-bottom-sheet',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.CrossSellWidgetTripSavingsBottomSheetSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-savings-bottom-sheet',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetUnlockTripSavingBannerClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-unlock-trip-saving-banner',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetUnlockTripSavingBannerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-unlock-trip-saving-banner',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetHeaderSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-header',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetTripSavingsBottomSheetClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-savings-bottom-sheet',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.CrossSellWidgetActivitiesClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesFilterClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesFilterSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-filter',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesViewAllClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-view-all',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetActivitiesViewAllSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-activities-view-all',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightEditClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-edit',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightEditSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-edit',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightLoadingSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-loading',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightViewAllClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-view-all',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetFlightViewAllSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-flight-view-all',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetHotelClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-hotel',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetHotelSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-hotel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetTripSavingAppliedBannerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-saving-applied-banner',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetTripSavingAppliedBannerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-saving-applied-banner',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetTripSavingsBottomSheetClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-savings-bottom-sheet',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetTripSavingsBottomSheetSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-trip-savings-bottom-sheet',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetUnlockTripSavingBannerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-unlock-trip-saving-banner',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.CrossSellWidgetUnlockTripSavingBannerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'cross-sell-widget-unlock-trip-saving-banner',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGeoLocationDenyModalCloseButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-geo-location-deny-modal-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopCitiesCardClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-cities-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesTopCitiesCarouselArrowButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-cities-carousel-arrow-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopCitiesCarouselContainerSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-top-cities-carousel-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesMiniReviewContentClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-mini-review-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesMiniReviewContentRevealEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-mini-review-content',
        action_type: 'reveal',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesViewAllReviewsClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-view-all-reviews',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesViewAllReviewsRevealEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-view-all-reviews',
        action_type: 'reveal',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV10 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 10
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV10 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 10
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV10 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 10
    }
};
exports.ActivitiesGeoLocationDenyModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-geo-location-deny-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesGeoLocationNotFoundModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-geo-location-not-found-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextNearMeItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-near-me-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextNearMeItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-near-me-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesClearAllHistoryClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-clear-all-history',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEditSearchCloseButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-edit-search-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEditSearchDateInputClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-edit-search-date-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEditSearchModalSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-edit-search-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEditSearchSearchInputClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-edit-search-search-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEmptyStatePopularDestinationsClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-empty-state-popular-destinations',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesEmptyStateSuggestionContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-empty-state-suggestion-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEmptyStateTopActivitiesClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-empty-state-top-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesErrorComponentSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-error-component',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesHeaderSearchBarClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-header-search-bar',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesHeaderSearchBarTextInputClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesHeaderSearchBarTextInputSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayCurrencyItemClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-currency-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayLanguageErrorModalSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-language-error-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayLanguageItemClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-language-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayTextSearchInputClearIconClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-input-clear-icon',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayTextSearchNoResultSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-no-result',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesOverlayTextSearchResultItemClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-result-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesPageContentErrorButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-page-content-error-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSearchButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-search-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesSearchHistoryItemClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-search-history-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesTopActivitiesAroundYouCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopActivitiesAroundYouCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopActivitiesAroundYouCarouselArrowButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-carousel-arrow-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopActivitiesAroundYouCarouselSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-activities-around-you-carousel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopDestinationCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-destination-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopDestinationContainerArrowButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-destination-container-arrow-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWhyChooseAgodaSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-why-choose-agoda',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEmptyStatePopularDestinationsClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-empty-state-popular-destinations',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEmptyStateTopActivitiesClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-empty-state-top-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV9 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 9
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV9 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 9
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV9 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 9
    }
};
exports.ActivitiesDismissInCitySearchClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-dismiss-in-city-search',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesInCitySearchResultClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-in-city-search-result',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
/**
 * Occurs on each action 'click' of element 'header-activities-links'
 */
exports.HeaderActivitiesLinksClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'header-activities-links',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesClearAllHistoryClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-clear-all-history',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchHistoryItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-history-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionClearButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-clear-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionClearButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-clear-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionGroupSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-group',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionNotificationSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-notification',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionRadioButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-radio-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferOptionRadioButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-option-radio-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTimeSlotNotificationSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-time-slot-notification',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCloseDatePickerTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-close-date-picker-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCloseDatePickerTextlinkSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-close-date-picker-textlink',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDummyAddToCartButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-dummy-add-to-cart-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDummyAddToCartButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-dummy-add-to-cart-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferDateChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-date-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOfferDateChipSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-offer-date-chip',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPleaseSelectDateNotificationSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-please-select-date-notification',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopoverCalendarChangeMonthButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popover-calendar-change-month-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopoverCalendarChangeMonthButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popover-calendar-change-month-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopoverCalendarClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popover-calendar',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPopoverCalendarSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-popover-calendar',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeOtherDatesTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-other-dates-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeOtherDatesTextlinkSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-other-dates-textlink',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationMapImageClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-map-image',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationMapImageRevealEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-map-image',
        action_type: 'reveal',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationViewMapButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-view-map-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLocationViewMapButtonRevealEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-location-view-map-button',
        action_type: 'reveal',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV8 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 8
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV8 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 8
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV8 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 8
    }
};
exports.ActivitiesCityHeaderDescriptionModalClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-city-header-description-modal',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCityHeaderDescriptionModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-city-header-description-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCityHeaderDescriptionShowMoreClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-city-header-description-show-more',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCityHeaderDescriptionShowMoreHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-city-header-description-show-more',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCityHeaderDescriptionShowMoreSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-city-header-description-show-more',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesQuickCategoryFilterContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-quick-category-filter-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesQuickCategoryFilterItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-quick-category-filter-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchPageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-page',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeAllActivitiesClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-all-activities',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopCitiesCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-cities-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopCitiesCarouselContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-cities-carousel-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayCurrencyItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-currency-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayLanguageErrorModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-language-error-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayLanguageItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-language-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesErrorComponentSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-error-component',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPageContentErrorButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-page-content-error-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaqsContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-faqs-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaqsContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-faqs-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaqsItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-faqs-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaqsItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-faqs-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPackageOptionSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-package-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesDateChipButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-date-chip-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesMoreDatesButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-more-dates-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsSelectedOfferOptionSeenEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-booking-details-selected-offer-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesBookingErrorPopupClickClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-booking-error-popup-click',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesBookingErrorPopupSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-booking-error-popup',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesBookingFigurePanelSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-booking-figure-panel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesMosaicGalleryClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-mosaic-gallery',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewNoResultSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-no-result',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewTranslateButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-review-translate-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBadgeHoverEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBadgeSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesFaQsContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-fa-qs-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaQsContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-fa-qs-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaQsItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-fa-qs-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFaQsItemSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-fa-qs-item',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBadgeHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBadgeSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-badge',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDealsBadgesContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-deals-badges-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHighlightBadgesContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-highlight-badges-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardImageClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-image',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardImageNavBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-image-nav-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardImageNavBtnSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-image-nav-btn',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardImageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-image',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardTruncateTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-truncate-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewCardTruncateTextlinkSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-card-truncate-textlink',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewFilterChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-filter-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewListSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-list',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewModalCloseBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-modal-close-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewOverviewCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-overview-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewOverviewCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-overview-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewPaginationNavBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-pagination-nav-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewSortChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-sort-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewTranslateButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-review-translate-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeAllReviewButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-all-review-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeReviewTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-review-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLoadFailedClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-load-failed',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLoadFailedSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-load-failed',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardImageClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-image',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardImageNavBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-image-nav-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardImageNavBtnSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-image-nav-btn',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardImageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-image',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardTruncateTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-truncate-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsCardTruncateTextlinkSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-card-truncate-textlink',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsFilterChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-filter-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsListSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-list',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsModalCloseBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-modal-close-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsPaginationNavBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-pagination-nav-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsSortChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-sort-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesReviewsTranslateButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-reviews-translate-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeAllReviewsButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-all-reviews-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSeeReviewsTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-see-reviews-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopReviewsCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-reviews-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopReviewsCardSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-reviews-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchSelectedFilterChipClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-selected-filter-chip',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchSelectedFilterClearAllButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-selected-filter-clear-all-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesFilterDurationOptionClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesFilterPriceSliderThumbClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-filter-price-slider-thumb',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesSortOptionClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesOptionCardSeeDetailClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesOptionCardSeeDetailHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesOptionCardSeeDetailSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailHoverEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardHoverEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardTimeClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardTimeHoverEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesAvailableOptionCardTimeSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesBookingOptionsBookButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-options-book-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingOptionsChangeDateClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-options-change-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV7 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 7
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV7 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 7
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV7 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 7
    }
};
exports.ActivitiesDetailsPageTabClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-details-page-tab',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLandingSearchButtonClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-landing-search-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesOverlayTextSearchResultItemClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-result-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPackageOptionSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-package-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPackageOptionShowMoreButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-package-option-show-more-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesPaginationNextBtnClickEventActivitiesManifestV7 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 7
    }
};
exports.ActivitiesPaginationPrevBtnClickEventActivitiesManifestV7 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 7
    }
};
exports.ActivitiesEditSearchCloseButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-edit-search-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEditSearchDateInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-edit-search-date-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEditSearchModalSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-edit-search-modal',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesEditSearchSearchInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-edit-search-search-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHeaderSearchBarClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-header-search-bar',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLandingDateInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-landing-date-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLandingSearchInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-landing-search-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDetailsPackageOptionChangeDateClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-details-package-option-change-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesAdultCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-adult-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAdultCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-adult-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAvailabilityChangeDateClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-availability-change-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesAvailabilityUpdateButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-availability-update-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesAvailabilityUpdateButtonSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-availability-update-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardTimeClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardTimeHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesAvailableOptionCardTimeSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-book-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-book-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingOptionsBookButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-options-book-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingOptionsChangeDateClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-options-change-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingOptionsCloseButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-options-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingOptionsUpdateButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-options-update-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCalendarButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-calendar-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCalendarButtonSelectDateClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-calendar-button-select-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesChildCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-child-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesChildCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-child-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesInfantCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-infant-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesInfantCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-infant-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOptionCardSeeDetailClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOptionCardSeeDetailHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOptionCardSeeDetailSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOriginalPriceSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-original-price',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesPersonCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-person-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPersonCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-person-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesSeniorCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-senior-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesSeniorCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-senior-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesYouthCounterMinusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-youth-counter-minus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesYouthCounterPlusClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-youth-counter-plus',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
/**
 * Occurs on each action 'seen' of element 'header-menu-links'
 */
exports.HeaderMenuLinksSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'header-menu-links',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesAdditionalInfoContainerClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesAdditionalInfoContainerSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCancellationContainerClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCancellationContainerSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesDepartureReturnContainerClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesDepartureReturnContainerSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesIntroductionSummaryContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-introduction-summary-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesIntroductionSummaryContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-introduction-summary-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSimCardContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-sim-card-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSimCardContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-sim-card-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSuggestedRouteContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-suggested-route-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSuggestedRouteContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-suggested-route-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWhatsIncludedContainerClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-whats-included-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWhatsIncludedContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-whats-included-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectContainerClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesWhatToExpectContainerSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesNoSearchResultsPageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-no-search-results-page',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsSelectedOfferOptionSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-booking-details-selected-offer-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesNoResultClearFilterClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-no-result-clear-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesNoResultNewSearchClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-no-result-new-search',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesNoResultUpdateFilterClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-no-result-update-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCategoriesFilterClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-categories-filter',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFilterDurationOptionClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesPaginationNextBtnClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesPaginationPrevBtnClickEventActivitiesManifestV6 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 6
    }
};
exports.ActivitiesSortOptionClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesFilterDurationOptionClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPaginationNextBtnClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesPaginationPrevBtnClickEventActivitiesManifestV5 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 5
    }
};
exports.ActivitiesSortOptionClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesFilterDurationOptionClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesPaginationNextBtnClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesPaginationPrevBtnClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesSortOptionClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV4 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 4
    }
};
exports.ActivitiesPaginationNextBtnClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesPaginationPrevBtnClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesTypRedirectBannerCloseButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-typ-redirect-banner-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTypRedirectBannerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-typ-redirect-banner',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTypRedirectBannerTextlinkClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-typ-redirect-banner-textlink',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsSelectedOfferOptionSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-details-selected-offer-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingErrorPopupClickClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-error-popup-click',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingErrorPopupSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-error-popup',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingFigurePanelSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-figure-panel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingPaymentButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-booking-payment-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingPaymentProcessingPopupSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-payment-processing-popup',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesLandingSearchButtonClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-landing-search-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesBookingDetailsBookForSomeoneClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-details-book-for-someone',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingDetailsContinuePaymentButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-details-continue-payment-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingDetailsContinuePaymentButtonDisableSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-details-continue-payment-button-disable',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingDetailsSelectedOfferOptionSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-details-selected-offer-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingErrorPopupClickClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-error-popup-click',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingErrorPopupSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-error-popup',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingFigurePanelSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-figure-panel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingLocationOverlaySeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-location-overlay',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingLocationTextBoxSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-location-text-box',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingNotSeeLocationClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-not-see-location',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingPaymentButtonClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-payment-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingTypDetailSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-typ-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingTypMessageSeenEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-typ-message',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingTypReturnHomeClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-booking-typ-return-home',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesOverlayTextSearchResultItemClickEventActivitiesManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-result-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 2
    }
};
exports.ActivitiesBookingDetailsBookForSomeoneClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-details-book-for-someone',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsContinuePaymentButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-details-continue-payment-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsContinuePaymentButtonDisableSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-details-continue-payment-button-disable',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingDetailsSelectedOfferOptionSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-details-selected-offer-option',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingErrorPopupClickClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-error-popup-click',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingErrorPopupSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-error-popup',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingFigurePanelSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-figure-panel',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingLocationOverlaySeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-location-overlay',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingLocationTextBoxSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-location-text-box',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingNotSeeLocationClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-not-see-location',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingPaymentButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-payment-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingTypDetailSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-typ-detail',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingTypMessageSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-typ-message',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingTypReturnHomeClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-typ-return-home',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardContentHoverEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesCardContentSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOriginalPriceSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-original-price',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingOptionsChangeDateClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-options-change-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingOptionsBookButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-options-book-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingOptionsCloseButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-options-close-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesBookingOptionsUpdateButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-booking-options-update-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchInputClearIconClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-input-clear-icon',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchNoResultSeenEventActivitiesManifestV3 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-no-result',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 3
    }
};
exports.ActivitiesOverlayTextSearchResultItemClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-result-item',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHeaderSearchBarTextInputClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesHeaderSearchBarTextInputSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-header-search-bar-text-input',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesCalendarButtonSelectDateClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-calendar-button-select-date',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSelectDateButtonClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-select-date-button',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSelectDateButtonHoverEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-select-date-button',
        action_type: 'hover',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSelectDateButtonSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-select-date-button',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
/**
 * Occurs on each action 'seen' of element 'header-menu-links'
 */
exports.HeaderMenuLinksSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'header-menu-links',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopDestinationCardClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-destination-card',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesTopDestinationContainerSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-top-destination-container',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDetailFloatingBackBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-detail-floating-back-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesDetailFloatingBackBtnSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-detail-floating-back-btn',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchFloatingBackBtnClickEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-floating-back-btn',
        action_type: 'click',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesSearchFloatingBackBtnSeenEventActivitiesManifestV1 = {
    ids: {
        action_element_name: 'activities-search-floating-back-btn',
        action_type: 'seen',
        app_data: 'activities',
        event_version: 1
    }
};
exports.ActivitiesFilterDurationOptionClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-filter-duration-option',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesFilterPriceSliderThumbClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-filter-price-slider-thumb',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesFilterStarRatingOptionClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-filter-star-rating-option',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSortAndFilterApplyButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-apply-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSortAndFilterClearButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-clear-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSortAndFilterOpenButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-sort-and-filter-open-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSortOptionClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-sort-option',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCancellationPolicyInfoModalCloseButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-policy-info-modal-close-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCancellationPolicyItemClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-policy-item',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAdditionalInfoContainerClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAdditionalInfoContainerSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesAdultCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-adult-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAdultCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-adult-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAvailabilityChangeDateClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-availability-change-date',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailabilityUpdateButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-availability-update-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailabilityUpdateButtonSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-availability-update-button',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardClickEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailClickEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'click',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailHoverEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'hover',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardHoverEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardTimeClickEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'click',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardTimeHoverEventManifestV3 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'hover',
        event_version: 3
    }
};
exports.ActivitiesAvailableOptionCardTimeSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesBookCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-book-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesBookCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-book-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCalendarButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-calendar-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCancellationContainerClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCancellationContainerSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesCancellationInfoSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-cancellation-info',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesCardContentClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCardContentHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesCardContentSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesCardFeaturesClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCardFeaturesHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesCardPriceClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCardPriceHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesCardTitleClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCardTitleHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesChildCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-child-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesChildCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-child-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesCpFooterClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-cp-footer',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesDepartureReturnContainerClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesDepartureReturnContainerSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesDepartureReturnInfoSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-departure-return-info',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesDetailsAdditionalInfoSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-details-additional-info',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesErrorButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-error-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesFooterContactUsClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-footer-contact-us',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesFooterHomeClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-footer-home',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesFooterPrivacyClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-footer-privacy',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesFooterTcClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-footer-tc',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesImageCarouselClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesImageCarouselHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesImageCarouselSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesInclusionListClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesInclusionListHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesInclusionListSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesInfantCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-infant-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesInfantCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-infant-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesLandingSearchButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-landing-search-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesLandingTextInputClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-landing-text-input',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesLanguageOrCurrencyErrorModalSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-language-or-currency-error-modal',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesMissingDestinationErrorModalSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-missing-destination-error-modal',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesNotSupportedLanguageErrorModalSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-not-supported-language-error-modal',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesOptionCardSeeDetailClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesOptionCardSeeDetailHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesOptionCardSeeDetailSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesOverlayTextSearchNoResultSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-no-result',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesOverviewClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesOverviewHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesOverviewSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesPaginationNextBtnClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPaginationPrevBtnClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPersonCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-person-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPersonCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-person-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPointClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPointHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesPointSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesPriceClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesPriceHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesPriceSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesSeeOptionButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesSeeOptionButtonHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesSeeOptionButtonSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesSeniorCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-senior-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesSeniorCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-senior-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesWhatToExpectContainerClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesWhatToExpectContainerSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesWhatToExpectInfoSeenEventManifestV2 = {
    ids: {
        action_element_name: 'activities-what-to-expect-info',
        action_type: 'seen',
        event_version: 2
    }
};
exports.ActivitiesYouthCounterMinusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-youth-counter-minus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesYouthCounterPlusClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-youth-counter-plus',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAdditionalInfoContainerSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardTimeClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardTimeHoverEventManifestV2 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'hover',
        event_version: 2
    }
};
exports.ActivitiesAvailableOptionCardTimeSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesCancellationContainerSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesCancellationInfoSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-info',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesCardContentSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesDepartureReturnContainerSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesDepartureReturnInfoSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-departure-return-info',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesDetailsAdditionalInfoSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-details-additional-info',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesImageCarouselSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesInclusionListSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesLanguageOrCurrencyErrorModalSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-language-or-currency-error-modal',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesMissingDestinationErrorModalSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-missing-destination-error-modal',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesNotSupportedLanguageErrorModalSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-not-supported-language-error-modal',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesOptionCardSeeDetailSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchNoResultSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-no-result',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesOverviewSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesPointSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesPriceSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesSeeOptionButtonSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesSelectorChangeDateClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-selector-change-date',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesSelectorUpdateButtonClickEventManifestV2 = {
    ids: {
        action_element_name: 'activities-selector-update-button',
        action_type: 'click',
        event_version: 2
    }
};
exports.ActivitiesSelectorUpdateButtonSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-selector-update-button',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectContainerSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectInfoSeenEventManifestV1 = {
    ids: {
        action_element_name: 'activities-what-to-expect-info',
        action_type: 'seen',
        event_version: 1
    }
};
exports.ActivitiesFooterContactUsClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-contact-us',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesFooterHomeClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-home',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesFooterPrivacyClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-privacy',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAdditionalInfoContainerClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAdditionalInfoContainerRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-additional-info-container',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesAdultCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-adult-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAdultCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-adult-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardChooseButtonRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-choose-button',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardFooterDetailRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-footer-detail',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardTimeClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardTimeHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesAvailableOptionCardTimeRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-available-option-card-time',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesBookCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-book-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesBookCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-book-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCalendarButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-calendar-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCancellationContainerClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCancellationContainerRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-container',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesCancellationInfoRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cancellation-info',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesCardContentClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCardContentHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesCardContentRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-content',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesCardFeaturesClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCardFeaturesHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-features',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesCardPriceClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCardPriceHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-price',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesCardTitleClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCardTitleHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-card-title',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesChildCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-child-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesChildCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-child-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesCpFooterClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-cp-footer',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesDepartureReturnContainerClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesDepartureReturnContainerRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-departure-return-container',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesDepartureReturnInfoRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-departure-return-info',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesDetailsAdditionalInfoRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-details-additional-info',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesErrorButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-error-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesFooterContactUsRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-contact-us',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesFooterHomeRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-home',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesFooterPrivacyRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-privacy',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesFooterTcClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-footer-tc',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesImageCarouselClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesImageCarouselHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesImageCarouselRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-image-carousel',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesInclusionListClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesInclusionListHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesInclusionListRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-inclusion-list',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesInfantCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-infant-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesInfantCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-infant-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesLandingSearchButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-landing-search-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesLandingTextInputClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-landing-text-input',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesLanguageOrCurrencyErrorModalRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-language-or-currency-error-modal',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesMissingDestinationErrorModalRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-missing-destination-error-modal',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesNotSupportedLanguageErrorModalRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-not-supported-language-error-modal',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesOptionCardSeeDetailClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesOptionCardSeeDetailHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesOptionCardSeeDetailRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-option-card-see-detail',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesOverlayTextSearchNoResultRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overlay-text-search-no-result',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesOverviewClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesOverviewHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesOverviewRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-overview',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesPaginationNextBtnClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-pagination-next-btn',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPaginationPrevBtnClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-pagination-prev-btn',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPersonCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-person-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPersonCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-person-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPointClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPointHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesPointRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-point',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesPriceClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesPriceHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesPriceRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-price',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesSeeOptionButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSeeOptionButtonHoverEventManifestV1 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'hover',
        event_version: 1
    }
};
exports.ActivitiesSeeOptionButtonRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-see-option-button',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesSelectorChangeDateClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-selector-change-date',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSelectorUpdateButtonClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-selector-update-button',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSelectorUpdateButtonRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-selector-update-button',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesSeniorCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-senior-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesSeniorCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-senior-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectContainerClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectContainerRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-what-to-expect-container',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesWhatToExpectInfoRevealEventManifestV1 = {
    ids: {
        action_element_name: 'activities-what-to-expect-info',
        action_type: 'reveal',
        event_version: 1
    }
};
exports.ActivitiesYouthCounterMinusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-youth-counter-minus',
        action_type: 'click',
        event_version: 1
    }
};
exports.ActivitiesYouthCounterPlusClickEventManifestV1 = {
    ids: {
        action_element_name: 'activities-youth-counter-plus',
        action_type: 'click',
        event_version: 1
    }
};
